import { Checkbox, FormControlinputLabel, Grid, Input, InputLabel } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { SecondaryButton, SelectBox } from '../../../../Core/FormInput';
import { MandatoryField, SimpleField } from '../../../../Core/FormInput/inputfields';
import { postDriverRates } from '../../../../Core/Service/wipSales-Services/driverRateSales-service';
import { List } from '@material-ui/icons';
import { set } from 'lodash';
import {
    getLocationDetailsByID,
    getLocationDetailsScreenDropdown,
    postLocationDetails
} from '../../../../Core/Service/wipSales-Services/locationDetails-service';
import { use } from 'react';
import AppContext from '../../../../App/AppContext';

const AddLocationDetails = (props) => {
    const [form, setForm] = useState({
        locationDetailID: null,
        locationDetailTypeID: null,
        locationDetailCode: '',
        locationDetailName: '',
        locationDetailAddressLine1: '',
        locationDetailAddressLine2: '',
        locationDetailTown: '',
        locationDetailCounty: '',
        locationDetailPostCode: '',
        locationDetailCountry: '',
        locationDetailPhone: '',
        locationDetailFax: '',
        locationDetailEmail: '',
        locationDetailWebsite: '',
        locationDetailContactName: '',
        locationDetailContactEmail: '',
        locationDetailContactPhone: ''
    });

    const { rowID, row, onClose } = props;
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        locationTypesDropdown: []
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const pullLocationTypesDropdown = async () => {
        try {
            let res = await getLocationDetailsScreenDropdown();
            console.log('Location Types Dropdown:', res);
            if (res.success) {
                setState((st) => ({
                    ...st,
                    locationTypesDropdown: res?.data?.list?.table || []
                }));
            }
        } catch (err) {
            console.error('Error fetching location types dropdown:', err);
        }
    };

    const pullDetails = async (ID) => {
        try {
            let res = await getLocationDetailsByID(ID);
            let data = res.data.list[0];
            if (res.success) {
                setForm({
                    locationDetailID: data.locationDetailID,
                    locationDetailTypeID: data.locationDetailTypeID,
                    locationDetailCode: data.locationDetailCode,
                    locationDetailName: data.locationDetailName,
                    locationDetailAddressLine1: data.locationDetailAddressLine1,
                    locationDetailAddressLine2: data.locationDetailAddressLine2,
                    locationDetailTown: data.locationDetailTown,
                    locationDetailCounty: data.locationDetailCounty,
                    locationDetailPostCode: data.locationDetailPostCode,
                    locationDetailCountry: data.locationDetailCountry,
                    locationDetailPhone: data.locationDetailPhone,
                    locationDetailFax: data.locationDetailFax,
                    locationDetailEmail: data.locationDetailEmail,
                    locationDetailWebsite: data.locationDetailWebsite,
                    locationDetailContactName: data.locationDetailContactName,
                    locationDetailContactEmail: data.locationDetailContactEmail,
                    locationDetailContactPhone: data.locationDetailContactPhone
                });
            }
        } catch (err) {
            console.error('Error fetching location details:', err);
        }
    };

    useEffect(() => {
        pullLocationTypesDropdown();
    }, []);

    useEffect(() => {
        if (rowID) pullDetails(rowID);
    }, [rowID]);

    const validate = () => {
        let temp = {};

        // REQUIRED FIELDS
        if (!form.locationDetailTypeID) temp.locationDetailTypeID = 'Location Type is required';

        // MAX LENGTH RULES
        if (form.locationDetailCode?.length > 20) temp.locationDetailCode = 'Max 20 characters allowed';

        if (form.locationDetailName?.length > 50) temp.locationDetailName = 'Max 50 characters allowed';

        if (form.locationDetailAddressLine1?.length > 50) temp.locationDetailAddressLine1 = 'Max 50 characters allowed';

        if (form.locationDetailAddressLine2?.length > 50) temp.locationDetailAddressLine2 = 'Max 50 characters allowed';

        if (form.locationDetailTown?.length > 32) temp.locationDetailTown = 'Max 32 characters allowed';

        if (form.locationDetailCounty?.length > 50) temp.locationDetailCounty = 'Max 50 characters allowed';

        if (form.locationDetailPostCode?.length > 8) temp.locationDetailPostCode = 'Max 8 characters allowed';

        if (form.locationDetailCountry?.length > 50) temp.locationDetailCountry = 'Max 50 characters allowed';

        if (form.locationDetailPhone?.length > 20) temp.locationDetailPhone = 'Max 20 characters allowed';

        if (form.locationDetailFax?.length > 20) temp.locationDetailFax = 'Max 20 characters allowed';

        if (form.locationDetailEmail?.length > 100) temp.locationDetailEmail = 'Max 100 characters allowed';

        if (form.locationDetailWebsite?.length > 50) temp.locationDetailWebsite = 'Max 50 characters allowed';

        if (form.locationDetailContactName?.length > 50) temp.locationDetailContactName = 'Max 50 characters allowed';

        if (form.locationDetailContactEmail?.length > 50) temp.locationDetailContactEmail = 'Max 50 characters allowed';

        if (form.locationDetailContactPhone?.length > 20) temp.locationDetailContactPhone = 'Max 20 characters allowed';

        setErrors(temp);
        return Object.keys(temp).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        const payload = { ...form };
        console.log('Payload to submit:', payload);

        try {
            const res = await postLocationDetails(payload);

            if (res.success) {
                showToast(res.data?.message || 'Location Details saved successfully', 'success');
                onClose(true);
            } else {
                showToast(res.message || 'Failed to save Location Details', 'error');
            }
        } catch (error) {
            console.error('Submit Error:', error);

            showToast(error?.response?.data?.message || error?.message || 'Unexpected error occurred while saving.', 'error');
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit} noValidate>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} lg={4}>
                        <InputLabel small shrink style={{ marginBottom: 10 }} error>
                            Location Type
                        </InputLabel>
                        <SelectBox
                            List={state.locationTypesDropdown}
                            name="locationDetailTypeID"
                            // label="Location Type"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailTypeID}
                            onChange={handleChange}
                            inputProps={{ maxLength: 50 }}
                            error={!!errors.locationDetailTypeID}
                            helperText={errors.locationDetailTypeID}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailCode"
                            inputLabel="Code"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailCode}
                            onChange={handleChange}
                            error={!!errors.locationDetailCode}
                            helperText={errors.locationDetailCode}
                            inputProps={{ maxLength: 20 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailName"
                            inputLabel="Name"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailName}
                            onChange={handleChange}
                            error={!!errors.locationDetailName}
                            helperText={errors.locationDetailName}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailPhone"
                            inputLabel="Phone"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailPhone}
                            onChange={handleChange}
                            error={!!errors.locationDetailPhone}
                            helperText={errors.locationDetailPhone}
                            inputProps={{ maxLength: 20 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailFax"
                            inputLabel="Fax"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailFax}
                            onChange={handleChange}
                            error={!!errors.locationDetailFax}
                            helperText={errors.locationDetailFax}
                            inputProps={{ maxLength: 20 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailEmail"
                            inputLabel="Email"
                            variant="outlined"
                            type="email"
                            fullWidth
                            value={form.locationDetailEmail}
                            onChange={handleChange}
                            error={!!errors.locationDetailEmail}
                            helperText={errors.locationDetailEmail}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={6}>
                        <SimpleField
                            name="locationDetailAddressLine1"
                            inputLabel="Address Line 1"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailAddressLine1}
                            onChange={handleChange}
                            error={!!errors.locationDetailAddressLine1}
                            helperText={errors.locationDetailAddressLine1}
                            inputProps={{ maxLength: 200 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={6}>
                        <SimpleField
                            name="locationDetailAddressLine2"
                            inputLabel="Address Line 2"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailAddressLine2}
                            onChange={handleChange}
                            error={!!errors.locationDetailAddressLine2}
                            helperText={errors.locationDetailAddressLine2}
                            inputProps={{ maxLength: 200 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailTown"
                            inputLabel="Town"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailTown}
                            onChange={handleChange}
                            error={!!errors.locationDetailTown}
                            helperText={errors.locationDetailTown}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailCounty"
                            inputLabel="County"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailCounty}
                            onChange={handleChange}
                            error={!!errors.locationDetailCounty}
                            helperText={errors.locationDetailCounty}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailCountry"
                            inputLabel="Country"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailCountry}
                            onChange={handleChange}
                            error={!!errors.locationDetailCountry}
                            helperText={errors.locationDetailCountry}
                            inputProps={{ maxLength: 50 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailPostCode"
                            inputLabel="Post Code"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailPostCode}
                            onChange={handleChange}
                            error={!!errors.locationDetailPostCode}
                            helperText={errors.locationDetailPostCode}
                            inputProps={{ maxLength: 20 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailWebsite"
                            inputLabel="Website"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailWebsite}
                            onChange={handleChange}
                            error={!!errors.locationDetailWebsite}
                            helperText={errors.locationDetailWebsite}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailContactName"
                            inputLabel="Contact Name"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailContactName}
                            onChange={handleChange}
                            error={!!errors.locationDetailContactName}
                            helperText={errors.locationDetailContactName}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailContactEmail"
                            inputLabel="Contact Email"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailContactEmail}
                            onChange={handleChange}
                            error={!!errors.locationDetailContactEmail}
                            helperText={errors.locationDetailContactEmail}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                        <SimpleField
                            name="locationDetailContactPhone"
                            inputLabel="Contact Phone"
                            variant="outlined"
                            fullWidth
                            value={form.locationDetailContactPhone}
                            onChange={handleChange}
                            error={!!errors.locationDetailContactPhone}
                            helperText={errors.locationDetailContactPhone}
                            inputProps={{ maxLength: 20 }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <SecondaryButton variant="contained" color="primary" fullWidth type="submit">
                            Save
                        </SecondaryButton>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
};
export default AddLocationDetails;
